// import React from 'react'

// const CreateReason = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default CreateReason


import { useState, useEffect, useContext } from "react";
import {
  AppBar,
  Typography,
  Button,
  TextField,
  Box,
  Breadcrumbs, IconButton,
  Link, Tooltip,
  Autocomplete, List,
  ListItem,
  ListItemText, ListItemSecondaryAction,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { PageDataContext } from "../../utils/common/PageDataContext";
import {
  SETTING_API_16,
  SETTING_API_17
} from "../../api/ApiModel";
import { externalgetApi } from "../../services/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import { externalpostApi } from "../../services/externalApis";
import { useLocation } from "react-router-dom";
import SystemAlert from "../../components/common/SystemAlert";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
 import { Divider } from "@mui/material";
function CreateReason() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const location = useLocation();
  const { selectedItem } = location.state || {};
  const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
  const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
  const [alertMessage, setAlertMessage] = useState("");
  const SYS_USER = useSelector((state) => state.user) || {};
  const { LOCCODE, STAFFMAPLOCODE, RESTCODE, USERNAME, COMPCODE } =
    SYS_USER.USER_PARAM || {};
  const isEdit = location.state?.actionText === "Edit";
  // const [selectedreasoncatcode, setSelectedreasoncatcode] = useState("");
  const [datadoccat, setDatadoccat] = useState(null);
  const [selectedItemDetails, setSelectedItemDetails] = useState({
   
    descrip: "",
    reasoncatcode: "",
    reasontypecode: "",
   
  });

      const [items, setItems] = useState([]);

  const { selectedreasoncatcode, selectedreasoncatname, actionText } = location.state || {};

  useEffect(() => {
    if (selectedItem) {
      setSelectedItemDetails({
        doctype: selectedItem.doctype,
        descrip: selectedItem.descrip,
        reasontypecode: selectedItem.reasontypecode,
        reasoncatcode: selectedItem.reasoncatcode,
        docsavecode: selectedItem.docsavecode,
      });
    }
  }, [selectedItem]);

  console.log("Selected Item Details:", selectedItemDetails);

  useEffect(() => {
    setPageData({
      title: "Reason Types",
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, []);

  const goBackToView = () => {
    navigate("/vreasontypes");
  };

  const handleInputChanges = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }

    // Validate max length
    if (typeof value === "string" && value.length > 30) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot exceed 30 characters.",
      }));
      return;
    }

    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }

    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const cleanInputValue = (name, value) => {
  if (typeof value !== "string") return value;

  // Example: clean leading spaces for all inputs, or per field if needed
  return value.replace(/^\s+/, ""); // remove leading spaces
};

  const handleInputChange = (e) => {
  const { name, value } = e.target;

  // Auto-clean the input (remove leading spaces)
  const cleanedValue = cleanInputValue(name, value);
  const trimmedValue = typeof cleanedValue === "string" ? cleanedValue.trim() : cleanedValue;

  // Prevent initial space only (optional after clean)
  if (typeof value === "string" && value.length === 1 && value[0] === " ") {
    return;
  }

  // Validate max length
  if (typeof cleanedValue === "string" && cleanedValue.length > 30) {
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "Input cannot exceed 30 characters.",
    }));
    return;
  }

  // Validate empty or space-only input
  if (typeof cleanedValue === "string" && trimmedValue === "") {
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "Input cannot be empty or just spaces.",
    }));
  } else {
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  }

  // Always update with the cleaned value
  setSelectedItemDetails((prevDetails) => ({
    ...prevDetails,
    [name]: cleanedValue,
  }));
};
  const handleInputChangecode = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }

    // Validate max length
    if (typeof value === "string" && value.length > 6) {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot exceed 5 characters.",
      }));
      return;
    }

    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }

    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  const handleInputChangedes = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;

    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }

    // Validate empty string
    if (typeof value === "string" && trimmedValue === "") {
      setError((prevError) => ({
        ...prevError,
        [name]: "Input cannot be empty or just spaces.",
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }

    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_16, "get", {
          STS: CON_STATUS_ACTIVE,
        });

        setDatadoccat(result);

        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTING_API_17, "get", {
          COMPCODE,
          LOCCODE: STAFFMAPLOCODE,

          reasoncatcode: selectedreasoncatcode,
          STS: CON_STATUS_ACTIVE || "D",
        });

        setData(result);
        console.log("result", result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const result = await externalgetApi(
        `${SETTING_API_17}/${selectedreasoncatcode}`,
        "get",
        { reasoncatcode: selectedreasoncatcode }
      );

      setItems(result);
      console.log("result", result);
    } catch (err) {
      setError(err);
      console.error("Fetch error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  if (selectedreasoncatcode) {
    fetchData();
  }
}, [selectedreasoncatcode]);


  const handleCancel = () => {
    setSelectedItemDetails({
      doctype: "",
      descrip: "",
      docsavecode: "",
    });
  };

  const handleConfirmClick = async () => {
    setIsButtonDisabled(true);
    const { doctype, doccatname, reasoncatcode,descrip } = selectedItemDetails;

    const requiredFields = [
    //   { name: "doctype", value: doctype, label: "Document Name" },

      {
        name: "doccatname",
        value: selectedreasoncatcode,
        label: "Reason Category Name",
      },

     
        { name: "descrip", value: descrip, label: "Reason" },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setError(newError);

      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      //  const errorMessage = `Required fields: ${missingFieldLabels}.`;
      const errorMessage = `Please Fill All the Required Fields.`;
      setAlertType("error");
      setAlertMessage("Please Fill All the Required Fields.");
      setAlertOpen(true); // Open the alert
      setIsButtonDisabled(false);
      return;
    }

if (data) {
  const isDuplicate = data.some((item) => {
    const isSameDescription =
      item.descrip?.trim().toLowerCase() === descrip?.trim().toLowerCase();

    //  Always use the selected category from location/state
    const isSameCategory =
      String(item.reasoncatcode) === String(selectedreasoncatcode);

    //  Exclude the current record when editing
    const isDifferentRecord =
      !isEdit || item.reasontypecode !== selectedItemDetails.reasontypecode;

    return isDifferentRecord && isSameDescription && isSameCategory;
  });

  if (isDuplicate) {
    setAlertMessage("Reason already exists in this category.");
    setAlertType("warning");
    setAlertOpen(true);
    setIsButtonDisabled(false);
    return;
  }
}


    const BRAND_CODE = selectedItem ? selectedItem.reasontypecode : 0;
    console.log("Brand Code:", BRAND_CODE);

    const staticValues = {
      COMPCODE,
      LOCCODE: STAFFMAPLOCODE,

      reasoncatcode: selectedreasoncatcode
        ? parseInt(selectedreasoncatcode, 10)
        : selectedItemDetails.reasoncatcode
        ? parseInt(selectedItemDetails.reasoncatcode, 10)
        : 0,
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
      reasontypecode: BRAND_CODE,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SETTING_API_17, payload);
      console.log("Success:", responseData);
      setAlertMessage(
        `${isEdit ? "Updated Successfully!" : "Created Successfully!"}`
      );
      setAlertType("success");

      setAlertOpen(true);
      setSelectedItemDetails({
        doctype: "",
        descrip: "",
        docsavecode: "",
      });
    } catch (error) {
      console.error("Error:", error);
      setAlertType("error");
      setAlertMessage("An unexpected error occurred.");
      setAlertOpen(true); // Open the alert
    }
    // setTimeout(() => {
    //   navigate("/vreasontypes");
    // }, 2000);
  };

  const isDescripInList = items.some(
  (item) =>
    item.descrip?.trim().toLowerCase() === selectedItemDetails.descrip?.trim().toLowerCase()
);


  return (
    <>
      <Box sx={styles.box_breadcrumb}>
        <Tooltip title="Back to Reason Types" arrow sx={styles.breadcrumb_tooltip}>
          <IconButton
            aria-label="back"
            sx={styles.btn_breadcrumb_back}
            onClick={goBackToView}
          >
            <ArrowBackIcon sx={styles.btn_breadcrumb_back_icon} />
          </IconButton>
        </Tooltip>
        <Typography sx={styles.breadcrumb_divider}>|</Typography>

        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            Home
          </Link>
          <Link
            sx={styles.breadcrumb_link}
            underline="hover"
            // href=""
          >
            Settings
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
      {isEdit ? "Edit Reason Types" : "Create Reason Types"} 
          </Link>
        </Breadcrumbs>
      </Box>
      <Box sx={styles.box_add_page_container}>
        <AppBar sx={styles.appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              item
              size={{ xs: 8, sm: 10, md: 10, lg: 10, xl: 10 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
         
                {isEdit ? "Edit Reason Types" : "Create Reason Types"} : {selectedreasoncatname}
              </Typography>
            </Grid>
          </Grid>
        </AppBar>
     



<Box
  component="form"
  noValidate
  autoComplete="off"
  sx={styles.add_form_page_container}
>
  <Grid
    container
    spacing={2}
    sx={styles.add_form_page_grid_container}
    alignItems="stretch"
  >
    {/* Left Section */}
<Grid
 item
      size={{ xs: 12, sm: 6, md: 5, lg: 5, xl: 5 }}
      sx={{ display: "flex", flexDirection: "column" }}
>
  <Typography sx={styles.appbar_title}>
         
            Reasons Types
              </Typography>
<List dense sx={{ p: 0,mt:2, maxHeight: 400, overflow: 'auto' }}>
  {items.map((item) => (
    <ListItem
      key={item.id}
      sx={{
        borderRadius: 2,
        boxShadow: "0px 1px 5px rgba(0,0,0,0.1)",
        mb: 1,
        bgcolor: "#fff",
        "&:hover": {
          bgcolor: "#f5f5f5",
        },
        px: 2,
        py: 1.5,
      }}
    >
      <ListItemText
        primary={item.descrip}
        primaryTypographyProps={{
          fontSize: "14px",
          fontWeight: 500,
          color: "#333",
        }}
      />
      <ListItemSecondaryAction>
   <Button
  variant="contained"
  color="primary"
  size="small"
  startIcon={<AddCircleOutlineIcon />}
  sx={{
    bgcolor: "#1976d2",
    "&:hover": { bgcolor: "#115293" },
    textTransform: "none",
  }}
  onClick={() =>
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      descrip: item.descrip, // Set the text field
    }))
  }
>
  Add
</Button>


      </ListItemSecondaryAction>
    </ListItem>
  ))}
</List>

</Grid>

    {/* Vertical Divider */}
    <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />

    {/* Right Section */}

       <Grid
      item
      size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
      sx={{ display: "flex", flexDirection: "column" }}
    >

      {/* <Autocomplete
        options={Array.isArray(datadoccat) ? datadoccat : []}
        getOptionLabel={(option) => option.reasoncatname || ""}
        disableClearable
        value={
          Array.isArray(datadoccat)
            ? datadoccat.find(
                (item) =>
                  item.reasoncatcode === selectedItemDetails.reasoncatcode
              ) || null
            : null
        }
        onChange={(event, newValue) => {
          const reasoncatcode = newValue ? newValue.reasoncatcode : "";
          setSelectedreasoncatcode(reasoncatcode);

          handleInputChange({
            target: { name: "reasoncatcode", value: reasoncatcode },
          });
          handleInputChange({
            target: {
              name: "doccatname",
              value: newValue ? newValue.doccatname : "",
            },
          });
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={
              <span>
                Reason Category Name <span style={{ color: "red" }}> *</span>
              </span>
            }
            variant="outlined"
            error={!!error?.doccatname}
            helperText={error?.doccatname}
            size="small"
            name="doccatname"
            FormHelperTextProps={{
              sx: { fontSize: "12px", color: "red" },
            }}
          />
        )}
        ListboxProps={{
          style: { maxHeight: 150, backgroundColor: theme.palette.background.paper },
        }}
      /> */}

         <TextField
        id="description"
        label="Reason Category"
        variant="outlined"
        fullWidth
        required
        size="small"
        name="descrip"
        value={selectedreasoncatname}
        disabled
        // onChange={handleInputChange}
        // error={!!error.descrip}
         sx={{ mt: 2 }}  // <-- Added margin top
        // helperText={error.descrip}
        FormHelperTextProps={{
          sx: { fontSize: "12px", color: "red" },
        }}
      />

    <TextField
  id="description"
  label="Reason Types"
  variant="outlined"
  fullWidth
  required
  size="small"
  name="descrip"
  value={selectedItemDetails.descrip}
  onChange={handleInputChange}
  error={!!error.descrip}
  sx={{ mt: 2 }}
  helperText={error.descrip}
  FormHelperTextProps={{
    sx: { fontSize: "12px", color: "red" },
  }}
  disabled={isDescripInList}
/>
    </Grid>
 
  </Grid>
</Box>

        <Box sx={styles.add_form_page_button_box}>
          <Button
            variant="outlined"
            size="medium"
            sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
            onClick={handleCancel}
            
          >
            Clear
          </Button>
          <Button
            variant="contained"
            size="medium"
            sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
            onClick={handleConfirmClick}
          
          >
            {isEdit ? "Modify" : "Confirm"}
          </Button>
        </Box>

        <SystemAlert
          open={alertOpen}
          type={alertType}
          message={alertMessage}
          onClose={() => setAlertOpen(false)}
        />
      </Box>
    </>
  );
}

export default CreateReason;
